export default __webpack_public_path__ + "media/images/banner/banner-32-b109b0764c403f3b443643a79c2132c8.jpg";